import { propTypes } from "prop-types"
import React from "react"
import dayjs from "dayjs"
import PropTypes from "prop-types"
// components
import { TimePicker as AntTimePicker } from "antd"

const TimePicker = ({
  className,
  defaultValue,
  allowClear = true,
  format = "h:mm:ss A",
  use12Hours = true,
  value,
  onChange, // parent function to call
  placeholder = "Select time",
  ...moreProps // size,
}) => {
  const classNames = ["prime-date-picker"]

  if (className) classNames.push(className)

  const handleChange = (evt) => {
    if (evt) {
      onChange(evt.format(format))
    } else {
      onChange(null)
    }
  }

  return (
    <AntTimePicker
      placeholder={placeholder}
      onChange={handleChange}
      className={classNames.join(" ")}
      value={dayjs(value, format).isValid() && value ? dayjs(value, format) : undefined}
      defaultValue={dayjs(defaultValue, format).isValid() && defaultValue ? dayjs(defaultValue, format) : undefined}
      allowClear={allowClear}
      format={format}
      use12Hours={use12Hours}
      {...moreProps}
    />
  )
}

TimePicker.propTypes = {
  /**
   * Sets the placeholder text when no value is selected.
   */
  placeholder: PropTypes.string,

  /**
   * If set to true, 12 hour format will be used, otherwise 24 hour format will be used.
   */
  use12Hours: PropTypes.bool,

  /**
   * Defines the time format (e.g., "h:mm:ss A", h:mm:ss, h:mm, h).
   */
  format: PropTypes.string,

  /**
   * Specifies the initial time to display, in the format specified by `format` prop.
   */
  defaultValue: PropTypes.string,

  /**
   * Represents the current selected time, in the format specified by `format` prop.
   */
  value: PropTypes.string,

  /**
   * Called when the selected time changes.
   */
  onChange: PropTypes.func,

  /**
   * Adds a custom CSS class to the component.
   */
  className: PropTypes.string,

  /**
   * Determines whether the user can clear the field.
   */
  allowClear: PropTypes.bool,
}

export default TimePicker
